import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useTickets from "./hooks/useTickets";
import LimitedTicketBlock from "./LimitedTicketBlock";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "./style.scss";

const PassesColorPage: React.FC = () => {
  const ticketSaleHeader = useSelector((state: State) => state.config.configuration.sortByColorsHeader);

  const { colorGroup, requestGetColorGroups } = useTickets();

  useEffect(() => {
    requestGetColorGroups();
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        {colorGroup && (
          <React.Fragment>
            {colorGroup.map((item, index) => (
              <div key={index}>
                <LimitedTicketBlock item={item} sortType="colorGroupPasses" />
              </div>
            ))}
          </React.Fragment>
        )}
        <div>
          {/* <b>Jakieś tam imprezy</b> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default PassesColorPage;
